import { render } from "./DemoGame.vue?vue&type=template&id=38f65506&scoped=true&ts=true"
import script from "./DemoGame.vue?vue&type=script&lang=ts"
export * from "./DemoGame.vue?vue&type=script&lang=ts"

import "./DemoGame.vue?vue&type=style&index=0&id=38f65506&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f65506"]])

export default __exports__